<script>
// TODO 修改图片服务器的地址
    const imgUrl='https://sclingfeng.oss-cn-chengdu.aliyuncs.com/zhqy/';
    // const URL = 'http://localhost:8769/'
    // const newUrl = 'http://localhost:8769/'
    // const URL = 'https://zhqy.sclf.top/api'
    // const newUrl = "https://zhqy.sclf.top/api"
    const URL = ''
    const newUrl = ''

    function NumAutoPlusAnimation(targetEle, options) {
        if(options.num<1){
            return 0
        }
        options = options || {};
        let $this = document.getElementById(targetEle),
        time = options.time || $this.data('time'), //总时间--毫秒为单位
        finalNum = options.num || $this.data('value'), //要显示的真实数值
        regulator = options.regulator || 100, //调速器，改变regulator的数值可以调节数字改变的速度
        step = finalNum / (time / regulator),/*每30ms增加的数值--*/
        count = options.count, //计数器
        initial = 0;
        let timer = setInterval(function() {
          count = count + step;
          if(count >= finalNum) {
              clearInterval(timer);
              count = finalNum;
          }
          //t未发生改变的话就直接返回
          //避免调用text函数，提高DOM性能
          let t = Math.floor(count);
          if(t == initial) return;

          initial = t;

          $this.innerHTML = initial;
        }, 30);
    }
    function checkPhone(phone){
        if(!(/^1[3456789]\d{9}$/.test(phone))){
            return false;
        }
    }
    function isCardNo(card){
        // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(reg.test(card) === false) {
            return false;
        }
    }
    function isPwd(pwd){
        if(!(/^[a-zA-Z0-9]{6,18}$/.test(pwd))){
            return false;
        }
    }
    // 时间戳转换  (定义前先商量是否*1000)
    function date(ns){return new Date(parseInt(ns) * 1000).toLocaleString().split(' ')[0].replace(/\//g,'-');}
    export default
    {
        imgUrl,//用户地址
        URL,
        newUrl,
        checkPhone,   //手机号码正则
        isCardNo,   //身份证正则
        isPwd,   //密码正则
        date,
        NumAutoPlusAnimation,    //时间+-
    }
</script>
